<div class="unsaved-dialog">
  <p class="unsaved-message">You have unsaved changes.</p>
  <div class="unsaved-actions">
    <button class="btn-ignore" (click)="onIgnore()">Ignore</button>
    <button class="btn-save" (click)="onSave()">Save changes</button>
  </div>
</div>
